__turbopack_context__.v({
  "field-footer": "field-footer-module-scss-module__pxg4nq__field-footer",
  "icon": "field-footer-module-scss-module__pxg4nq__icon",
  "state-default": "field-footer-module-scss-module__pxg4nq__state-default",
  "state-error": "field-footer-module-scss-module__pxg4nq__state-error",
  "state-success": "field-footer-module-scss-module__pxg4nq__state-success",
});
